/**
 * Query-key factory for the Requirements module. Mirrors the project
 * keys' shape so cache invalidation patterns transfer cleanly.
 */
export const requirementKeys = {
  all: ["requirements"] as const,
  spec: (projectId: string) =>
    [...requirementKeys.all, "spec", projectId] as const,
};
